<template>
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <router-link to="/Home/Index">
                <i class="fa fa-dashboard"> </i>
                {{resource('Breadcrumb_Home')}}
            </router-link>
        </li>
        
        <!--:key="breadcrumb.to"  -->
        <id-dispenser :elements="breadcrumbs">
            <template v-slot="{ idsPerElement }">
                <router-link
                    v-for="breadcrumb in breadcrumbs"
                    :key="idsPerElement.get(breadcrumb)"
                    :to="breadcrumb.to"

                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <li class="breadcrumb-item" :class="{ active: isExactActive }">
                        <a v-if="!isExactActive" :href="href" @click="navigate">
                            {{ breadcrumb.displayName }}
                        </a>
                        <template v-else>
                            {{ breadcrumb.displayName }}
                        </template>
                    </li>
                </router-link>
            </template>
        </id-dispenser>

    </ol>
</template>

<script>
    import idDispenser from '../../Components/Util/IdDispenser.vue';
    import resourceMixin from "../../Util/Mixins/resources";
    
    export default {
        name: 'layout-breadcrumbs',
        components: {
            idDispenser
        },
        mixins: [resourceMixin],
        computed: {
            breadcrumbs(){
                const {params, matched} = this.$route;
                
                return matched
                    .filter(r => r.meta && r.meta.breadcrumb)
                    .map(({name, path, meta: { breadcrumb: displayName }}) => {
                        const to = { params: params };
                        
                        //https://router.vuejs.org/guide/essentials/navigation.html
                        //params are only used when a 'name' is provided
                        //additionally, a 'path' is to be absent
                        if(name) to.name = name;
                        if(path) to.path = path;
                        
                        return {
                            to,
                            displayName
                        }
                    });
            }
        }
    }
</script>